import request from '@/utils/request'
// 获取路由
export const getRouters = (corp) => {
  return request({
    url: '/prod-api/auth/wecom/authorization', method: 'get', params: corp
  })
}
// 通过code获取登录凭证
export const postWecomLogin = (data) => {
  return request({
    url: '/prod-api/auth/wecom/login' + data, method: 'post'
  })
}

// 客户查询
export const getCustomer = (data) => {
  return request({
    url: '/prod-api/booking/manage/customer', method: 'post', data
  })
}

// 查询登录员工信息
export const getInfo = () => {
  return request({
    url: '/prod-api/system/user/getInfo', method: 'get'
  })
}

// 查询预约列表
export const getManageList = (data) => {
  return request({
    url: '/prod-api/booking/manage/list', method: 'post', data
  })
}

// 查询治疗项目列表
// export const getProjectList = (jgbm, data) => {
//   return request({
//     url: `/system/data/project/${jgbm}`, method: 'GET', params: data
//   })
// }
// 查询治疗项目列表(新接口)
export const getProjectList = (data) => {
  return request({
    url: `/prod-api/booking/wecom/data/project`, method: 'post', data: data
  })
}

// 查询预约时间段数据
export const getTimeSlot = (data) => {
  return request({
    url: '/prod-api/booking/wecom/timeSlot', method: 'post', data
  })
}

// 查询预约医生列表
export const getProjectDoctor = (orgId, project) => {
  return request({
    url: `/prod-api/system/data/projectDoctor/${orgId}`, method: 'GET', params: {project}
  })
}

// 查询预约排班医生列表 
export const getDoctorsByRoster = (project) => {
  return request({
    url: `/prod-api/booking/wecom/doctorsByRoster`, method: 'post', data: project
  })
}

// 通过机构返回员工
export const getDataWorker = (orgId, search) => {
  return request({
    url: `/prod-api/system/data/worker/${orgId}`, method: 'GET', params: {search}
  })
}

// 通过机构返回排班员工
export const getCounselorByRoster = (search) => {
  return request({
    url: `/prod-api/booking/wecom/counselorByRoster`, method: 'post', data: search
  })
}



// 通过机构返回科室数据
export const getDataDept = (orgId) => {
  return request({
    url: `/prod-api/system/data/dept/${orgId}`, method: 'GET'
  })
}

// 预约创建/修改/取消
export const postWecomAppointment = (data) => {
  return request({
    url: '/prod-api/booking/wecom/appointment', method: 'post', data
  })
}

// 查询项目关联的设备
export const getProjectDevice = (orgId, project) => {
  return request({
    url: `/prod-api/system/data/projectDevice/${orgId}`, method: 'GET', params: {project}
  })
}

// 查询预约记录列表
export const postWecomList = (data) => {
  return request({
    url: '/prod-api/booking/wecom/list', method: 'post', data
  })
}

// 查询客户所有预约记录列表
export const postManageList = (data) => {
  return request({
    url: '/prod-api/booking/wecom/listByCustomer', method: 'post', data
  })
}

// 通过机构返回医生数据
export const getDataDoctor = (orgId) => {
  return request({
    url: `/prod-api/system/data/doctor/${orgId}`, method: 'get'
  })
}
// 机构返回医生数据
export const getListYgInfo = (data) => {
  return request({
    url: `/prod-api/system/listYgInfo`, method: 'get', params: data
  })
}

// 机构返回面诊医生数据
export const listInterviewDoctor = (data) => {
  return request({
    url: `/prod-api/booking/rosterManagement/listInterviewDoctor`, method: 'post', data: data
  })
}

export const getWecomSignature = (params) => {
  return request({
    url: `/prod-api/auth/wecom/signature?corpId=${params.corpId}&url=${params.url}`,
    method: 'get',
  })
}
export const getWecomAgentSignature = (params) => {
  return request({
    url: `/prod-api/auth/wecom/agentSignature?corpId=${params.corpId}&url=${params.url}`,
    method: 'get',
    settings: {isLoad: true}
  })
}

export const getCustomerByWxid = (data) => {
  return request({
    url: `/prod-api/booking/manage/customer/bywxid`,
    method: 'post',
    data
  })
}

// 查询任务列表
export const getTaskList = (params) => {
  return request({
    url: '/prod-api/booking/userTaskInfo/list',
    method: 'get',
    params,
  })
}

// 新增任务
export const addTask = (data) => {
  return request({
    url: '/prod-api/booking/userTaskInfo/add',
    method: 'post',
    data
  })
}

// 获取任务详情
export const getTaskDetail = (id) => {
  return request({
    url: `/prod-api/booking/userTaskInfo/${id}`,
    method: 'get'
  })
}

// 根据部门类别获取用户列表
export const getUserListByDept = (deptCategory) => {
  return request({
    url: '/prod-api/system/user/list/listByDeptCategory',
    method: 'get',
    params: { deptCategory }
  })
}

// 编辑任务
export const editTask = (data) => {
  return request({
    url: '/prod-api/booking/userTaskInfo/edit',
    method: 'post',
    data
  })
}

// 取消任务
export const cancelTask = (id) => {
  return request({
    url: '/prod-api/booking/userTaskInfo/delete',
    method: 'get',
    params: { id }
  })
}

// 修改任务状态
export const updateTaskStatus = (id, status) => {
  return request({
    url: '/prod-api/booking/userTaskInfo/updateStatus',
    method: 'post',
    data: { id, status }
  })
}

// 切换机构
export const postAuthSwitchOrg = (project) => {
  return request({
    url: '/prod-api/auth/switchOrg', method: 'post', data: project
  })
}

// 查询美容师列表
export const getBeauticianList = (jgbm) => {
  return request({
    url: '/prod-api/system/user/list/post/post-beautician?jgbm='+jgbm,
    method: 'get'
  })
}
// 查询机构基础信息${jgbm}
export const getOrgInfo = (jgbm) => {
  return request({
    url: `/prod-api/system/orgInfo/${jgbm}`,
    method: 'get'
  })
}

// 新增客户照片记录
export const photoRecord = (data) => {
  return request({
    url: '/prod-api/system/photoRecord',
    method: 'post',
    data
  })
}

// 获取我的客户照片记录列表
export const getPhotoRecordList = (data) => {
  return request({
    url: '/prod-api/system/photoRecord/mime',
    method: 'get',
    params: data,
    settings: {isLoad: true}
  })  
}

// 上传图片到服务器
export const uploadImage = (data) => {
  return request({
    url: '/prod-api/resource/oss/upload',
    method: 'post',
    contentType: 'application/x-www-form-urlencoded',
    data
  })
}

//删除照片记录
export const deletePhotoRecord = (ids) => {
  return request({
    url: `/prod-api/system/photoRecord/${ids}`,
    method: 'DELETE',
  })
}

// 展示项目时间总览情况
export const postOverviewProjectTime = (data) => {
  return request({
    url: '/prod-api/booking/wecom/overviewProjectTime',
    method: 'post',
    data: data
  })  
}

// ============ 短信回访（message_reply）============
// 获取回访选项数据（问卷题目配置）
// export const getMessageReplySet = (data) => {
//   return request({
//     url: '/pic-api/message_reply/set.do',
//     method: 'post',
//     data,
//     contentType: 'multipart/form-data; boundary=----',
//   })
// }

// // 判读回访状态
// export const getMessageReplySelect = (data) => {
//   return request({
//     url: '/pic-api/message_reply/select.do',
//     method: 'post',
//     data,
//     contentType: 'multipart/form-data; boundary=----',
//   })
// }
// // 获取客户信息
// export const getUserInfo = (data) => {
//   return request({
//     url: '/pic-api/member/userInfo.do',
//     method: 'post',
//     data,
//     contentType: 'multipart/form-data; boundary=----',
//   })
// }

// 保存回访
export const editMessageReply = (data) => {
  return request({
    url: '/pic-api/message_reply/edit.do',
    method: 'post',
    data,
    contentType: 'multipart/form-data; boundary=----',
  })
}

// 获取回访问卷详情
export const getDataInfo = (data) => {
  return request({
    url: `/pic-api/message_reply/getDxwj/${data.id}`,
    method: 'get',
    data,
    contentType: 'multipart/form-data; boundary=----',
  })
}